<script>
  import { t } from '../../i18n/index.js';

  let { status = 'disconnected', deviceName = null } = $props();

  let statusClass = $derived(
    status === 'connected' ? 'bg-green-500' :
    status === 'checking' || status === 'reconnecting' || status === 'connecting' ? 'bg-yellow-500' :
    'bg-red-500'
  );

  let statusText = $derived(
    status === 'connected' && deviceName
      ? t('camera.connected', { name: deviceName })
      : status === 'connected'
        ? t('camera.connectedDefault')
        : status === 'connecting' && deviceName
          ? t('camera.connecting', { name: deviceName })
          : status === 'connecting'
            ? t('camera.connectingDefault')
            : status === 'checking'
              ? t('camera.checking')
              : status === 'reconnecting'
                ? t('camera.reconnecting')
                : t('camera.disconnected')
  );

  let isPulsing = $derived(status === 'reconnecting' || status === 'connecting');
</script>

<div class="flex items-center gap-2">
  <span class="status-dot w-2 h-2 rounded-full {statusClass}" class:animate-pulse={isPulsing}></span>
  <svg class="h-4 w-4 text-gray-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
  <span class="text-sm" class:animate-pulse={isPulsing}>{statusText}</span>
</div>
